import { useEffect } from 'react'
import { Title, Subtitle, SuccessGif, SuccessWrapper } from '~components'
import { usePreventBrowserBack, useStore } from '~hooks'
import { urlHandler } from '~utils/path'
import { track } from '@amplitude/analytics-browser'
import { trackAuthentication } from '~utils/analytics'

const Success = () => {
  const { register, uuid } = useStore()
  const url = `${process.env.REACT_APP_FRETEBRAS_SITE}/fretes/`

  usePreventBrowserBack()

  setTimeout(() => {
    window.location.href = urlHandler(url)
  }, 3500)

  useEffect(() => {
    trackAuthentication(uuid)
    track('cadastro_sucesso', {
      tipo_veiculo: register.vehicleType,
      tipo_carroceria: register.vehicleBody,
      rastreador: register.vehicleTracking,
    })
  }, [])

  return (
    <SuccessWrapper role="region">
      <SuccessGif />
      <Title>Parabéns!</Title>
      <Subtitle>A sua conta foi criada com sucesso na Fretebras!</Subtitle>
    </SuccessWrapper>
  )
}

export default Success
